import {
  isLoggedIn,
  ServiceError,
  SpinnerCenter,
  useRemoteConfigContext,
} from "@shapr3d/frontend-lib";
import { useSearchParams } from "react-router-dom";

import ErrorPage from "../../components/ErrorPage/ErrorPage";
import { GenericHeader } from "../../components/Headers/GenericHeader/GenericHeader";
import useAccount from "../../hooks/useAccount";
import { useHandleProjectInvitation } from "../../hooks/useHandleInvitation";
import { useProject } from "../../hooks/useProject";
import { useProjectPageTracking } from "../../hooks/useProjectPageTracking";
import { SearchParam, ServiceErrorCode } from "../../types";
import { navigateToAuth } from "../../utils/authUtils";
import ModelViewerPage from "../ModelViewerPage/ModelViewerPage";
import NotFoundPage from "../NotFoundPage/NotFoundPage";
import RequestAccessPage from "../RequestAccessPage/RequestAccessPage";
import RequestAccessPendingPage from "../RequestAccessPage/RequestAccessPendingPage";

import style from "./ProjectPageWrapper.module.css";

export const ProjectPageWrapper = () => {
  // Trigger account fetch to load remote config for logged-in users
  useAccount();
  const [searchParams] = useSearchParams();
  const { isLoading: isRemoteConfigLoading } = useRemoteConfigContext();
  const hasInvitationHash = searchParams.get(SearchParam.InvitationHash);
  const { isError: isInvitationError } = useHandleProjectInvitation();
  const { isError: isProjectError, error: projectError } = useProject(Boolean(hasInvitationHash));

  useProjectPageTracking(Boolean(hasInvitationHash));

  if (isRemoteConfigLoading) {
    return <SpinnerCenter />;
  }

  if (isInvitationError) {
    return (
      <div className={style.container}>
        <GenericHeader />
        <ErrorPage />
      </div>
    );
  }

  if (hasInvitationHash) {
    return <SpinnerCenter />;
  }

  if (!isLoggedIn() && !hasInvitationHash) {
    navigateToAuth();
    return null;
  }

  if (isProjectError) {
    if (
      projectError instanceof ServiceError &&
      projectError.hasCode(ServiceErrorCode.ProjectForbidden)
    ) {
      return (
        <div className={style.container}>
          <GenericHeader />
          <RequestAccessPage />
        </div>
      );
    }

    if (
      projectError instanceof ServiceError &&
      projectError.hasCode(ServiceErrorCode.ProjectPendingAccess)
    ) {
      return (
        <div className={style.container}>
          <GenericHeader />
          <RequestAccessPendingPage />
        </div>
      );
    }

    return (
      <div className={style.container}>
        <GenericHeader />
        <NotFoundPage isProjectPage />
      </div>
    );
  }

  return <ModelViewerPage />;
};
